import Legal, { H2, H3 } from "@/pages/Legal";

export default function Impressum() {
  return (
    <Legal title="Impressum" testId="impressum-page">
      <section>
        <H2>Angaben gemäß § 5 TMG</H2>
        <p>MKSL Consulting<br />Spritzenplatz 16<br />22765 Hamburg</p>
      </section>
      <section>
        <H2>Kontakt</H2>
        <p>E-Mail: advisory@schneider-ludorff.de</p>
      </section>
      <section>
        <H2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</H2>
        <p>Maximilian Schneider-Ludorff<br />Spritzenplatz 16<br />22765 Hamburg</p>
      </section>
      <section>
        <H2>Haftungsausschluss</H2>
        <H3>Haftung für Inhalte</H3>
        <p className="mb-4">Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
        <H3>Haftung für Links</H3>
        <p className="mb-4">Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.</p>
        <H3>Urheberrecht</H3>
        <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
      </section>
    </Legal>
  );
}
